import { track } from "../../../util/tealium";
import TEALIUM from "../../../enums/tealium-enums";

const cardActionMapper: { [key: string]: string } = {
  message_primary: "message_primary_applicant",
  call_primary: "call_primary_applicant",
  mobile_primary: "copy_primary_applicant_mobile",
  email_primary: "email_primary_applicant",
  message_applicant: "message_applicant",
  call_applicant: "call_applicant",
  mobile_applicant: "copy_applicant_mobile",
  email_applicant: "email_applicant",
  address_primary: "copy_primary_address",
};

export const viewAllApplicantsClickTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ABO_PROFILE,
    "",
    "view_all_applicants",
  );
};

export const cardActionClickTrack = (event?: string, isPrimary?: boolean) => {
  const clickAction = `${event}_${isPrimary === true ? "primary" : "applicant"}`;

  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ABO_PROFILE,
    "",
    cardActionMapper[clickAction],
  );
};

export const profileApplicantCardErrorTrack = () => {
  track(TEALIUM.U_TAG_METHOD.VIEW, "", "", TEALIUM.CATEGORY.ABO_PROFILE, "profile_error", "");
};
